export const SET_FATAL_ERROR = 'SET_FATAL_ERROR';
